import { render, staticRenderFns } from "./Vessel.vue?vue&type=template&id=2538e987&scoped=true&"
import script from "./Vessel.vue?vue&type=script&lang=js&"
export * from "./Vessel.vue?vue&type=script&lang=js&"
import style0 from "./Vessel.vue?vue&type=style&index=0&id=2538e987&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2538e987",
  null
  
)

export default component.exports